import React from 'react';
import { Star, Quote } from 'lucide-react';
export function ReviewsSection() {
  const reviews = [{
    quote: 'Bill and his team completely transformed our outdated kitchen. He was on-site every day, communicated clearly, and the craftsmanship is outstanding. Highly recommend BLC Custom Homes.',
    name: 'Sarah M.',
    location: 'Fresno, CA',
    project: 'Kitchen Remodel'
  }, {
    quote: 'Finding a reliable contractor is tough, but Bill made our master bath remodel stress-free. They finished on time, stayed on budget, and the final result exceeded our expectations.',
    name: 'David & Lisa T.',
    location: 'Clovis, CA',
    project: 'Master Bathroom'
  }, {
    quote: "We've used BLC for two major home projects now. Bill's attention to detail and honest approach is why we keep calling him back. A true professional who cares about his work.",
    name: 'Michael R.',
    location: 'Madera County',
    project: 'Multiple Projects'
  }];
  return <section className="py-20 bg-brand-offwhite" data-id="element-174">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-175">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-176">
          <h2 className="text-3xl md:text-4xl font-semibold text-brand-blue mb-4" data-id="element-177">
            What Our Clients Say
          </h2>
          <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-178">
            Real experiences from homeowners across the Central Valley
          </p>

          {/* Google Rating */}
          <div className="inline-flex items-center bg-white px-6 py-3 rounded-full shadow-sm border border-gray-200" data-id="element-179">
            <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-180">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" data-id="element-181" />
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-182" />
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" data-id="element-183" />
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-184" />
            </svg>
            <div className="flex text-[#FBBC04] mr-3" data-id="element-185">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-186" />)}
            </div>
            <span className="font-bold text-gray-900 mr-2" data-id="element-187">5.0</span>
            <span className="text-gray-600 text-sm" data-id="element-188">• 127+ Reviews</span>
          </div>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-189">
          {reviews.map((review, index) => <div key={index} className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow relative" data-id="element-190">
              {/* Google Logo Badge */}
              <div className="absolute top-6 right-6 flex items-center gap-1 bg-gray-50 px-2 py-1 rounded" data-id="element-191">
                <svg className="w-4 h-4" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-192">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" data-id="element-193" />
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-194" />
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" data-id="element-195" />
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-196" />
                </svg>
                <span className="text-xs font-medium text-gray-600" data-id="element-197">
                  Google
                </span>
              </div>

              <Quote className="w-10 h-10 text-brand-blue/10 mb-4" data-id="element-198" />

              <div className="flex text-[#FBBC04] mb-6" data-id="element-199">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-200" />)}
              </div>

              <p className="text-gray-700 text-lg mb-6 leading-relaxed font-body" data-id="element-201">
                "{review.quote}"
              </p>

              <div className="pt-6 border-t border-gray-100" data-id="element-202">
                <p className="font-bold text-brand-black text-lg" data-id="element-203">
                  {review.name}
                </p>
                <p className="text-sm text-brand-blue font-medium" data-id="element-204">
                  {review.project}
                </p>
                <p className="text-sm text-gray-500" data-id="element-205">{review.location}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}